<template>
    <div :class="audit_mode!=true&&previous!=true ? 'mb-5':'gray-600 font-scale-sm'">
        <div :class="previous==true ? 'p-3 gray-500 rounded border border-color-gray-300 bgray-100':''">
            <b-overlay :show="is_visible_by_pipeline==false"
                rounded="sm"
                opacity="0.8"
                bg-color="#efefef"
                >
                <div v-if="headers">
                    <div :class="[{'fw-500 f-110 border-bottom border-color-gray-300 mb-2': sub_name }]">
                        <span v-if="sub_data_header.required && sub_data_header.required==true">*</span>{{ showTranslation(sub_name, sub_name_e, sub_name_c) || sub_name }}
                    </div>
                    <div :class="[ { 'mb-3': sub_description }, 'mb-1']">
                        <template v-if="is_indicate_description">
                            <div class="mr-1 fw-500 d-inline px-0"> {{ showTranslation(sub_description, sub_description_e, sub_description_c) || sub_description }} </div>
                        </template>

                        <template v-if="tags && tags.length">
                            <span v-for="(tag, tag_idx) in tags" :key="`subs-${sub_coede}-tag-${tag_idx}`">
                                <template v-if="tag">
                                    <span class="ml-2 f-80 gray-500"> {{ tag }} </span>
                                </template>
                            </span>
                        </template>

                        <template v-if="!isFieldEmpty(sub_info)">
                            <b-button class="ml-2 p-0" variant="icon" size="lg" :id="`i-${ sub_code }`" @click="toggleVisible" v-b-tooltip.hover.focus :title="button_title" :aria-label="button_title">
                                <fa icon="info-circle"></fa>
                            </b-button>
                        </template>

                        <template v-if="sub_priority">
                            <b-badge :variant="badge_var" class="mx-2">{{ sub_priority }}</b-badge>
                        </template>

                        <template v-if="typeof previous_sub.sub_code !== 'undefined' && !previous">
                            <b-button v-b-toggle="previous_sub.sub_code" size="sm" variant="icon" class="ml-2" v-b-tooltip.hover.focus :title="$t('지난해 답변 확인하기')" :aria-label="$t('지난해 답변 확인하기')">
                                <fa icon="history"></fa>
                            </b-button>
                        </template>

                        <!-- sub_info 정보 -->
                        <template v-if="!isFieldEmpty(sub_info)">
                            <div v-if="is_visible"
                                :id="`sub_info-${sub_code}`"
                                class="mt-2 mb-3 px-1 blue f-90"
                                >
                                <fa icon="info-circle" class="mr-1"></fa>
                                <span v-html="showTranslation(sub_info, sub_info_e, sub_info_c) || sub_info"></span>
                            </div>
                        </template>

                        <!-- sub_condition -->
                        <div v-if="is_sub_condition_activated==true" :id="`sub_condition-${sub_code}`" class="my-2 py-2">
                            <b-form-checkbox :disabled="is_locked || is_disabled_by_parent" v-model="sub_condition.value" @change="radioSave"> {{ showTranslation(sub_condition.text, sub_condition.text_e, sub_condition.text_c) || sub_condition.text }} </b-form-checkbox>
                        </div>
                    </div>
                </div>
                
                <div class="pl-0 pl-md-3">
                    <!-- input_number 유형 Sub Component -->
                    <b-input-group :id="form_id">
                        <b-form-input v-model.trim="sub_data_contents.result"
                            :placeholder="sub_data_contents['placeholder']"
                            :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent || is_disabled_by_na"
                            v-number-format="'number'"
                            @change="textInputSave" 
                            @blur="textInputSave(true, true)"
                        />
                        <template #append v-if="sub_data_contents['unit']">
                            <b-input-group-text>
                                <strong>{{ sub_data_contents['unit'] }}</strong>
                            </b-input-group-text>
                        </template>
                    </b-input-group>

                    <!-- file 저장 --> 
                    <template v-if="sub_data_header.has_attachment">
                        <df-attached-file-url    
                            class="mt-3"
                            :sub_id="sub_id"
                            :sub_code="sub_code"
                            :sub_init_id="sub_init_id"
                            :company_id="company_id"
                            :company_name="company_name"
                            :campaign_id="campaign_id"
                            :disabled="is_disabled_attached"
                            :audit_mode="audit_mode"
                            :previous="previous"
                            :has_attachment="sub_data_header.has_attachment"
                            :label="label"
                            :key="is_loaded"
                            >
                        </df-attached-file-url>
                    </template>

                    <!-- 저장 validation -->
                    <template v-if="previous !== true && audit_mode !== true">
                        <div :class="validation_style" @click="retrySave" class="mt-2" role="status" aria-live="polite">
                            <fa v-if="validation_icon !=''" :icon="validation_icon"></fa> {{ validation_comment }}
                        </div>
                    </template>
                </div>
                
                <!-- Child Component -->
                <template v-if="child_subs && child_subs.length">
                    <sub-component v-for="(item, index) in child_subs"
                        :key="item.id"
                        :is_final_sub_component="index == child_subs.length -1 ? true : false"
                        :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent" 
                        :sub_type="item.sub_type" 
                        :item="item" 
                        :audit_mode="audit_mode" 
                        :is_disabled_by_parent="is_disabled_by_parent">
                    </sub-component>
                </template>
            
                <!-- is_visible_by_pipeline 조건에 따른 해당없음 overlay -->
                <template v-slot:overlay>
                    <DFPipelineOverlay :prev_sub_info="prev_sub_info"
                                       :pipeline_title="pipeline_title"
                    />
                </template>
            </b-overlay>
        </div>

        <!-- previous component -->
        <b-collapse v-if="print_mode !== true" :id="previous_sub.sub_code">
            <template v-if="typeof previous_sub.sub_code !== 'undefined' && previous != true">
                <sub-component
                    :sub_type="previous_sub.sub_type" :item="previous_sub"    
                    :disabled="true" :is_disabled_by_parent="true" :previous="true"
                    >
                </sub-component>
            </template>
        </b-collapse>
    </div>
</template>

<script>
import { SubComponentMixin } from '@core_mixins/SubComponentMixin'
import DFPipelineOverlay from "@core_components/client/components/subs/elements/DFPipelineOverlay";

export default {
    name: 'df-input-number',
    mixins: [SubComponentMixin],
    components: {
        DFPipelineOverlay,
    },
    data () {
        return{}
    },
    methods:{}
}
</script>

<style>

</style>
